// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3i0Ka","notes":"Notes_notes__10fId"};